module.exports = __webpack_public_path__ + "img/nft-mock.a2ef0e0.png";